import { render, staticRenderFns } from "./news-article.vue?vue&type=template&id=2094386a&"
import script from "./news-article.vue?vue&type=script&lang=js&"
export * from "./news-article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2094386a', component.options)
    } else {
      api.reload('2094386a', component.options)
    }
    module.hot.accept("./news-article.vue?vue&type=template&id=2094386a&", function () {
      api.rerender('2094386a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/news/news-article.vue"
export default component.exports